<template>
    <div class="page">
        <div class="form-list">
            <el-form :inline="true" class="demo-form-inline" size="medium" lable-position="rigt" label-width="120px">
                <el-row>
                    <el-form-item label="操作类型：">
                        <el-radio-group v-model="dataChange" size="medium" @input="dataChangeFun">
                            <el-radio-button v-for="(values) in dataChangeType" :label="values.id" :key="values.id">
                                {{ values.name }}
                            </el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item :label="this.dataChangeType[this.dataChange].name + '名称：'">
                        <el-input v-if="dataChange == 0" placeholder="请输入内容" v-model="params.paramname"
                            class="input-with-select" @keyup.enter.native="openSearch(813183934369792, 0, 'bgmName')">
                            <el-button @click="openSearch(813183934369792, 0, 'bgmName')" slot="append"
                                icon="el-icon-search"></el-button>
                        </el-input>
                        <el-input v-if="dataChange == 1" placeholder="请输入内容" v-model="params.paramname"
                            class="input-with-select" @keyup.enter.native="openSearch(3386264207560704, 0, 'bgmName')">
                            <el-button @click="openSearch(3386264207560704, 0, 'bgmName')" slot="append"
                                icon="el-icon-search"></el-button>
                        </el-input>
                        <el-input v-if="dataChange == 2" placeholder="请输入内容" v-model="params.paramname"
                            class="input-with-select" @keyup.enter.native="openSearch(3391151360249856, 0, 'bgmName')">
                            <el-button @click="openSearch(3391151360249856, 0, 'bgmName')" slot="append"
                                icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="首营日期：">
                        <el-date-picker v-model="firstOperationDate" type="date" format="yyyy 年 MM 月 dd 日"
                            value-format="timestamp" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item v-if="isShowFirstCompany" label="首次购进单位：">
                        <el-input placeholder="请输入内容" v-model="smName" class="input-with-select"
                            @keyup.enter.native="openSearch(3386264207560704, 1, 'bgmName')">
                            <el-button @click="openSearch(3386264207560704, 1, 'bgmName')" slot="append"
                                icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                </el-row>
                <el-form-item class="btn-box">
                    <el-button class="btn" type="primary" @click="submitGspTimeUpdate">提交</el-button>
                </el-form-item>

            </el-form>

        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>



<script>
import SearchScheme from "../../byComponents/SearchScheme.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataChangeType: [{
                id: 0,
                name: "商品"
            }, {
                id: 1,
                name: "供应商"
            }, {
                id: 2,
                name: "客户"
            }
            ],
            dataChange: 0,
            params: {
                businessId: '',
                paramname: '',
                newTime: '',
                ggmInitunit: ''
            },
            smName: "",
            isShowFirstCompany: true,
            firstOperationDate: "",
            DialogVisible: false,
            bgmName: "",
            seIndex: "",
            sendDataInfo: {
                gchmType: 0,
                depName: '',
                depId: '',
                opmName: '',
                opmId: '',
                applyReason: '',
                remark: ''
            },
            proInfo: {
                bgmName: '',
                bgmId: '',
                bgpUnitmeasurement: '', //商品单位
                spec: '', //商品规格
                manufacturer: '', //商品产地
            },
            seTitle: "",
            seWidth: "",
            parentSearchData: {
                smId: "",
            },

        }
    },
    methods: {
        dataChangeFun(e) {//切换客户/供应商/商品
            Object.keys(this.params).forEach(key => { this.params[key] = '' })//置空对象
            this.smName = ""
            this.firstOperationDate=""
            if (e == 0) {
                this.isShowFirstCompany = true
            } else {
                this.isShowFirstCompany = false
            }
        },
        //检索Id, 索引(表格中), 标识
        openSearch(sId, index, type) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        // 检索方案返回
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                if (this.dataChange == 0) {
                    if (this.seIndex == 0) {
                        this.params.businessId = val.bgmId;
                        this.params.paramname = val.bgmName;
                    } else {
                        this.smName = val.smName
                        this.params.ggmInitunit = val.ggmInitunit
                    }
                } else {
                    if (this.dataChange == 1) {
                        this.params.businessId = val.smId;
                        this.params.paramname = val.smName;
                    }
                    if (this.dataChange == 2) {
                        this.params.businessId = val.cmId;
                        this.params.paramname = val.cmName;
                    }
                }

                this.DialogVisible = false;
            }
        },//dialog标题
        getSearchName(e) {
            console.log(e)
        },
        getSeWidth() {

        },//提交修改
        async submitGspTimeUpdate() {
            let data = {
                "businessId": this.params.businessId,
                "ggmInitunit": this.params.ggmInitunit,
                "newTime": this.firstOperationDate
            }
            let res = await this.$http.gspTimeUpdate(data)
            if (res.status == 200) {
                this.$message({
                    message: res.message,
                    type: 'success'
                })
                Object.keys(this.params).forEach(key => { this.params[key] = '' })//置空对象
                this.smName = ""
                this.firstOperationDate=""
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                })
            }


        }
    }
}
</script>
<style scoped>
.page {
    padding: 10px;
}

.demo-form-inline {
    width: 400px;
}

.demo-form-inline .btn-box {
    display: flex;
    justify-content: center;
}
.demo-form-inline .btn-box .btn {
    width: 120px;
}
</style>